module.exports = __webpack_public_path__ + "img/pick3.26fa8872.png";